export default "__VITE_ASSET__mrwhmJb5__"